import { put, takeLatest } from "redux-saga/effects";
import { types } from "../action_types";
import { GET, POST } from "../../Utils/httpServices";
import CustomToster from "../../SharedComponents/CustomToaster";

function* GetSettingsSaga({ payload }) {
  const { page, limit } = payload;
  try {
    const settingsAllData_response = yield GET(
      `admin/settings/all?page=${page}&limit=${limit || 100}&name=${
        payload?.searchText || ""
      }`
    );

    const { docs, currentPage, itemsPerPage, totalDocs, totalPages } =
      settingsAllData_response?.data.data.result;

    const settings = docs;

    const pagination = {
      currentPage,
      itemsPerPage,
      totalDocs,
      totalPages,
    };

    if (settingsAllData_response?.status === 200) {
      yield put({
        type: types.GetSettingsRequestSuccess,
        payload: { settings, pagination },
      });
    } else {
      yield put({ type: types.GetSettingsRequestFailure });
    }
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.GetSettingsRequestFailure });
  }
}

function* CreateSettingsSaga({ payload }) {
  let { values, handleCloseModal, page } = payload;

  try {
    // Backend expects JSON body with type, unit, unitCount, priceInCrh
    const body = {
      type: values.type,
      unit: values.unit,
      unitCount: values.unitCount,
      priceInCrh: values.priceInCrh,
    };

    const createdSettingsData_response = yield POST(
      "admin/settings/createOrUpdateSetting",
      body
    );

    if (createdSettingsData_response?.status === 200) {
      yield put({
        type: types.CreateSettingsRequestSuccess,
      });
      yield put({
        type: types.GetCompaniesRequest,
        payload: { page },
      });
      CustomToster({
        type: "success",
        message: "Settings Created Successfully",
      });
    } else {
      yield put({ type: types.CreateSettingsRequestSuccess });
    }
    handleCloseModal();
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.CreateSettingsRequestFailure });
  }
}

function* EditSettingsSaga({ payload }) {
  let { body, type, handleCloseModal, page } = payload;

  try {
    // Backend uses createOrUpdateSetting for both create and update
    // It uses the 'type' field to find and update the setting
    const requestBody = {
      ...body,
      type: type, // Include type in the body for the backend to identify which setting to update
    };

    const editSettingsData_response = yield POST(
      "admin/settings/createOrUpdateSetting",
      requestBody
    );

    if (editSettingsData_response?.status === 200) {
      yield put({
        type: types.EditSettingsRequestSuccess,
      });

      yield put({
        type: types.GetSettingsRequest,
        payload: { page },
      });

      CustomToster({
        type: "success",
        message: "Settings Edited Successfully",
      });
    } else {
      yield put({ type: types.EditSettingsRequestFailure });
    }
    handleCloseModal();
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.EditSettingsRequestFailure });
  }
}

export default function* SettingsSaga() {
  yield takeLatest(types.GetSettingsRequest, GetSettingsSaga);
  yield takeLatest(types.CreateSettingsRequest, CreateSettingsSaga);
  yield takeLatest(types.EditSettingsRequest, EditSettingsSaga);
}
